import { SettingItem, Currency } from './types';

// Tyto hodnoty slouží jako počáteční sada pro naplnění prázdné databáze.
// Klíč 'id' se nepřidává, protože bude automaticky generován databází.

export const DEFAULT_COLORS = ['#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6', '#EC4899', '#6366F1', '#14B8A6'];

export const INITIAL_CATEGORIES: Omit<SettingItem, 'id'>[] = [
  { name: "Potraviny", color: DEFAULT_COLORS[0] },
  { name: "Restaurace", color: DEFAULT_COLORS[1] },
  { name: "Nákupy", color: DEFAULT_COLORS[2] },
  { name: "Auto", color: DEFAULT_COLORS[3] },
  { name: "Kultura", color: DEFAULT_COLORS[4] },
  { name: "Ostatní", color: DEFAULT_COLORS[5] },
];

export const INITIAL_PAYMENT_METHODS: Omit<SettingItem, 'id'>[] = [
  { name: "Kartou", color: DEFAULT_COLORS[6] },
  { name: "Hotově", color: DEFAULT_COLORS[0] },
  { name: "Převodem", color: DEFAULT_COLORS[2] },
  { name: "Neznámá", color: '#9CA3AF' },
];

export const INITIAL_TAGS: Omit<SettingItem, 'id'>[] = [
    { name: "OSVČ", color: DEFAULT_COLORS[4] }, 
    { name: "Dovolená", color: DEFAULT_COLORS[1] }, 
    { name: "Záruka", color: DEFAULT_COLORS[2] }
];

export const INITIAL_CURRENCIES: Omit<Currency, 'id'>[] = [
    { name: "CZK" },
    { name: "EUR" },
    { name: "USD" },
    { name: "PLN" },
];
